import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/verkehrszeichen-datenmodell.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/verkehrszeichen-datenmodell')({
  component: Content,
});
